import styled from 'styled-components/macro';
import { Link } from '../../../../shared-styles';

export const StyledLink = styled.span`
  ${Link}
`;
